import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsExcInfoImplEncoder } from "../../encoder/OpsExcInfoImplEncoder";

import * as CubiqTS from "../../index";
import { OpsExcInfo } from "../OpsExcInfo";

export class OpsExcInfoImpl extends ConcreteEncodable implements OpsExcInfo {
  public static enType: string = "com.bcdfx.model.OpsExcInfoImpl";

  /*FID=1*/
  public opsException: CubiqTS.OpsExcRecord | null = null;
  /*FID=2*/
  public exceptionId: CubiqTS.Long | null = null;
  /*FID=3*/
  public orderData: CubiqTS.OrderData | null = null;
  /*FID=4*/
  public deal: CubiqTS.Deal | null = null;
  /*FID=5*/
  public transactionData: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsExcInfoImplEncoder.Instance;
    this.setEncodableType(OpsExcInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsExcInfoImpl[" +
      "opsException=" +
      this.opsException +
      "exceptionId=" +
      this.exceptionId +
      "orderData=" +
      this.orderData +
      "deal=" +
      this.deal +
      "transactionData=" +
      this.transactionData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
